/**
 * The line to put in front of a user for a failure: the localized copy where the error carries
 * one, its own message where it does not. A string rather than the error itself, so it can sit in
 * a slice and survive serialization to the client.
 */
export const displayMessage = (error: unknown): string => {
  const localized = (error as { localizedMessage?: unknown } | null)?.localizedMessage
  if (typeof localized === 'string' && localized) return localized
  return error instanceof Error ? error.message : String(error)
}
